import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  Text,
  Image,
  Circle,
  Center,
  Flex,
  Link,
  Divider,
  Stack,
  Input,
  InputGroup,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  chakra,
  InputRightElement,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Textarea,
} from "@chakra-ui/react";
import moment from "moment";

import ReactMarkdown from "react-markdown";
import DynamicModal from "../../../components/dynamic-modal";

import MiniDropdownInput from "../../../components/mini-dropdown";
import {
  DropdownInput,
  PrimaryButton,
  PrimaryButtonIcon,
  PrimaryInput,
  SearchBar,
  Toaster,
} from "../../../components";
import { COLORS } from "../../../components/styles/colors";
import DatePicker from "../../../components/date-picker";
import ModalRight from "../../../components/modal-right";
import { updateCondition } from "../../../middleware/services/visits/patient-overview/updatehealth";
import {
  GetAIMedicineComposition,
  updateDoctorNotes,
} from "../../../middleware/services/visits/patient-overview/updatedoctornotes";

import {
  CorrectMedicalTermsUsingAI,
  FetchMedicineAIAnswer,
  FetchMedicineAIPrompts,
  FetchMyHealthAIData,
} from "../../../middleware/services/visits/aicalls";
import TypingLoader from "../../../components/typing-loader";
import AiModal from "../../../components/ai-modal/index";
import { handleAlphaDotAndSpace, handleAlphaNumericDotAndSpace, validationOfNumberWithOnly1Decimal } from "../../../auth";
import { GetMedicineName } from "../../../middleware/services/medications.js";
import MonthYearPicker from "../../date-monthyear";
import DropdownInputForVitals from "../../dropdown-input-forVitals/index.js";
import { languageCodeMap, languageOptions } from "../../language-dropdown/index.js";
import { useHybridTranscriber } from "../doctor-notes/cheif-complaint-audio/useHybridTranscriber.js";
import { useForm } from "react-hook-form";
import DropdownWithMultiLingual from "../../dropdown-multilingual/index.js";
import { GPUChatAudioManagerSpeechMode } from "../doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode.js";
import { AudioDisplayForClutter } from "../doctor-notes/notes-transcription/utils/audio-display-multi-lingual.js";


const formatDate = (dateString) => {
  if (!dateString) return "-";
  return moment(dateString).format("Do MMM, YYYY");
};

const fileTypeMappings = {
  pdf: "/assets/svgs/pdf-icon.svg",
  png: "/assets/imgs/png-icon.png",
  jpg: "/assets/imgs/jpg-icon.png",
  jpeg: "/assets/imgs/jpg-icon.png",
};

const getFileIcon = (fileName) => {
  const extension = fileName.split(".").pop().toLowerCase();
  return fileTypeMappings[extension] || "/assets/svgs/file-icon.svg"; // fallback image
};

const Medications = ({
  date,
  medicines,
  attachments,
  appointmentId,
  patientname,
  patientgender,
  patientage,
  patientId,
  doctorId,
  id,
  fetchPatientHealthData,
  showLoader,
  dismissLoader,
  showSuccessToast,
  showErrorToast,
  refreshDoctorNotes,
  scaleHeight = "auto",
  componentBg = "#fcfcfd",
  cardBg = "white",
}) => {
  //-------------------------------------------------

  const editmedications = useRef();

  const [idToUpdate, setIdToUpdate] = useState(null);
  const [medicinename, setMedicineName] = useState("");
  const [medicinetype, setMedicineType] = useState("Tablet");
  const [dosage, setMedicineDosage] = useState(null);
  const [dosageunit, setMedicineDosageUnit] = useState("mg");
  const [frequency, setMedicineDosageFrequency] = useState("");
  const [fromdate, setFromDate] = useState(moment().format("DD-MM-yyyy"));
  const [todate, setToDate] = useState(moment().format("DD-MM-yyyy"));
  // const [morning, setMorning] = useState("0");
  const [setevening, setEvening] = useState("0");
  // const [setnight, setNight] = useState("0");
  const [prescribedby, setPrescribedBy] = useState(null);
  const [hospitalname, setHospitalname] = useState(null);
  const [beforeFOOD, setBeforeFood] = useState("0");
  const [afterFOOD, setAfterFood] = useState("0");
  const [medicineComposition, setMedicineComposition] = useState("");
  const [foodTiming, setFoodTiming] = useState("before");

  // ------------------- AI Insights

  const chatContainerRef = useRef(null);
  const [aianswers, setAIAnswers] = useState([]);
  const [remainingquestions, setRemainingQuestions] = useState([]);
  const [aiquestion, setAIAnalysis] = useState(null);
  const [AiInput, setAiInput] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [animate, setAnimate] = useState(false);
  const [showAIModal, setShowAIModal] = useState(true);

  const AIChatModel = useRef();

  // useEffect(() => {
  //   console.log(medicines , "medicines")
  // }, [medicines])

  useEffect(() => {
    if (animate) {
      const timer = setTimeout(() => {
        setAnimate(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [animate]);

  useEffect(() => {
    // Scroll to bottom whenever aianswers changes
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [aianswers]);
  const fetchAiDoctorPrompts = async (medicinename) => {
    showLoader();
    setRemainingQuestions([]);
    setAiInput(null);
    setAIAnswers([]);
    setInitialRender(true);
    const result = await FetchMyHealthAIData(
      {},
      patientId,
      patientname,
      patientgender,
      patientage
    );
    // console.log(result);
    let Aiprompts = { ...result, medicinename };
    setAiInput(Aiprompts);
    const response = await FetchMedicineAIPrompts(Aiprompts);
    if (response.generated_question) {
      setAIAnalysis(response);
      setRemainingQuestions(response.generated_question);
      AIChatModel.current.openRight();
    }
    dismissLoader();
  };

  const GetAIAnswer = async (prompt) => {
    // Display question immediately
    const newQuestion = { question: prompt, answer: "" };
    setAIAnswers((prevState) => [...prevState, newQuestion]);

    // Remove the question from remaining questions immediately
    setRemainingQuestions((prevState) =>
      prevState.filter((question) => question.value !== prompt)
    );

    // Trigger animation
    setAnimate(true);

    // Set initialRender to false after the first question is clicked
    setInitialRender(false);
    let AichatInput = { ...AiInput, query: prompt };

    const response = await FetchMedicineAIAnswer(AichatInput);

    if (response) {
      // Replace "typing" with actual answer
      setAIAnswers((prevState) =>
        prevState.map((item) =>
          item.question === prompt && item.answer === ""
            ? { question: item.question, answer: response.answer }
            : item
        )
      );
    }
  };

  //--------------------- Other functionalities

  const [isChecked, setIsChecked] = useState(0);

  const handleIsCurrent = (e) => {
    if (e.target.checked) {
      setIsChecked(1);
    } else {
      setIsChecked(0);
    }
  };

  const [compositionEditKey, setCompositionEditKey] = useState(0); // to rerender the composition input box
  const fetchComposition = async (medicineName) => {
    if (!medicineName) {
      showErrorToast("Please enter medicine name first to fetch composition");
    } else {
      const inputData = {
        input: {
          name: medicineName,
        },
      };

      // console.log(inputData.input);

      try {
        // showLoader();
        // console.log(inputData);
        const result = await GetAIMedicineComposition(inputData.input);
        // console.log(result);
        if (result) {
          showSuccessToast("Fetched Medicine composition successfully");
          setMedicineComposition(result.chemical_composition);
          setCompositionEditKey((prevKey) => prevKey + 1);
        }
      } catch (error) {
        console.error("Error Fetching Medicine composition:", error);
        showErrorToast("An error occurred while Fetching Medicine composition");
      } finally {
        // dismissLoader();
      }

      // fetchDoctorNotes();

      // console.log("Clicked");
    }
  };

  const editmedicine = async () => {
    let input = {
      patientid: patientId,
      doctorid: doctorId,
      appointmentid: appointmentId,
      type: "medications",
      prescribedmedicineid: idToUpdate,
      medicinename: medicinename,
      medicinetype: medicinetype,
      dosage: dosage,
      "duration": durationValue && durationUnit ? (durationValue + " " + durationUnit) : durationValue,
      // startdate: null,
      // enddate: null,
      frequency: frequency,
      frequencytime: medicineFreqUnit,
      frequencyvalue: medicineFreqValue,
      morning: morning,
      evening: afternoon,
      night: night,
      // morning: morning,
      // // afternoon: "",
      // evening: setevening,
      // night: setnight,
      prescribedby: prescribedby,
      hospitalname: hospitalname,
      dosageunit: dosageunit,
      beforefood: beforeFOOD,
      afterfood: afterFOOD,
      iscurrentmedicine: isChecked,
      chemical_composition: medicineComposition,
      medicineactive: 1,

      // documentdate: today,
      // documents: filenameforUpload.map((filename) => ({ filename })),
    };
    // if (moment(input.startdate, "DD-MM-YYYY", true).isValid()) {
    //   input.startdate = moment(input.startdate, "DD-MM-YYYY").format(
    //     "YYYY-MM-DD"
    //   );
    // }
    // if (moment(input.enddate, "DD-MM-YYYY", true).isValid()) {
    //   input.enddate = moment(input.enddate, "DD-MM-YYYY").format("YYYY-MM-DD");
    // }

    // console.log(input, "Edit input");
    if (medicinename == "") {
      showErrorToast("Please specify or upload any medicine");
      return false;
    } else {
      showLoader();
      const result = await updateCondition(input);

      if (result) {
        showSuccessToast("Medicine updated Successfully");
        editmedications.current.closeRight();
        fetchPatientHealthData();
      }
      dismissLoader();
    }
  };

  const handleeditmedication = (item) => {
    // console.log(item, 'item for edit medication');
    setIdToUpdate(item.id);
    setMedicineName(item.name);
    setComposition(item.chemicalcomposition);
    setMedicineType(item.type);
    setMedicineDosage(item.dosage);
    setMedicineDosageUnit(item.dosageunit);
    setMedicineDosageFrequency(item.frequency);
    setMedicineFreqUnit(item.frequencytime)
    setMedicineFreqValue(item.frequencyvalue)
    // const stratdate = moment(item.startdate, "YYYY-MM-DD").format("DD-MM-yyyy");
    // const enddate = moment(item.enddate, "YYYY-MM-DD").format("DD-MM-yyyy");
    // setFromDate(stratdate);
    // setToDate(enddate);
    setMorning(item.inMorning);
    // setEvening(item.inEvening);
    setAfternoon(item.inEvening);
    setNight(item.inNight);
    setPrescribedBy(item.prescribedby);
    setHospitalname(item.prescribedhospitalname);
    setBeforeFood(item.beforefood);
    setAfterFood(item.afterfood);
    setMedicineComposition(item.chemicalcomposition);
    // setIsChecked(item.iscurrentmedicine);
    setIsChecked(item.iscurrentmedicine === "Current" ? 1 : 0);

    setDuration(item.duration);
    // if (item.frequency) {
    //   const parts = item.frequency.split(" "); 
    //   const value = parts[0]; 
    //   const unit = parts[1];  
    //   setMedicineDosageFrequency(value); 
    //   setMedicineFreqUnit(unit);  
    // }

    if (item.duration) {
        const parts = item.duration.split(" "); 
        const value = parts[0]; 
        const unit = parts[1];  
        // setMedicineFreqValue(value); 
        // setMedicineFreqUnit(unit);  
        setDurationValue(value); 
        setDurationUnit(unit);  
      }

    editmedications.current.openRight();
  };

  const handleChangeDosageUnit = (selectedOption) => {
    setMedicineDosageUnit(selectedOption.label);
  };

  const handlemedicinename = (event) => {
    setMedicineName(event.target.value);
  };

  const [dropdownMedType, setDropdownMedType] = useState("");
        const [selectedValue, setSelectedValue] = useState("");
        
        const additionalMedicineTypes = [
          "Respules",
          "Suspension",
          "Foam",
          "Suppository",
          "EA",
          "Device",
          "Box",
          "Spray",
          "Lotion",
          "Tube",
          "Gargle",
          "Powder",
          "Soap",
          "Aerosol",
          "Shampoo",
          "Topical Cleanser",
          "Custom"
        ];
        
        const handleDropdownMedTypeChange = (value) => {
          setMedicineType("");
          setDropdownMedType(value);
          setSelectedValue(value);
          handlemedicinetypechange(value);
        };
          const handlemedicinetypechange = (event, type = "") => {
            setMedicineType(event);
            setDropdownMedType("");
            setSelectedValue(event);
            // if(type == "filter"){
            //   setFilterMedicinetype(event);
            // }
            if(event == "Tablet" || event == "Capsule" || event == "Suppository" || event == "Sachet" || event == "Powder"){
              setMedicineDosageUnit("mg");
            }
            else if (event == "Syrup" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids" || event == "Drops" || event == "Suspension" || event == "Respules" || event == "Gargle" || event == "Shampoo" || event == "Topical Cleanser"){
              setMedicineDosageUnit("ml");
            }
            else if (event == "Ointment" || event == "Cream" || event == "Gel" || event == "Foam" || event == "Lotion" || event == "Tube" || event == "Soap"){
              setMedicineDosageUnit("grms");
            }
            else if (event == "Inhaler" || event == "Spray" || event == "Aerosol"){
              setMedicineDosageUnit("puffs");
            }
            else if (event == "EA" || event == "Device" || event == "Box"){
              setMedicineDosageUnit("each");
            }
            else if (event == "Custom"){
              // For custom, you might want to set a default or leave it empty
              setMedicineDosageUnit("");
            }
        };
        
//   const handlemedicinetypechange = (event, type) => {
//     setMedicineType(event);
//     // if(type == "filter"){
//     //   setFilterMedicinetype(event);
//     // }
//     if(event == "Tablet" || event == "Capsule" || event == "Suppository" || event == "Sachet" || event == "Powder"){
//       setMedicineDosageUnit("mg");
//     }
//     else if (event == "Syrup" || event == "Injection" ||  event == "Nebulization" ||  event == "IVFluids" || event == "Drops" || event == "Suspension" || event == "Respules" || event == "Gargle" || event == "Shampoo" || event == "Topical Cleanser"){
//       setMedicineDosageUnit("ml");
//     }
//     else if (event == "Ointment" || event == "Cream" || event == "Gel" || event == "Foam" || event == "Lotion" || event == "Tube" || event == "Soap"){
//       setMedicineDosageUnit("grms");
//     }
//     else if (event == "Inhaler" || event == "Spray" || event == "Aerosol"){
//       setMedicineDosageUnit("puffs");
//     }
//     else if (event == "EA" || event == "Device" || event == "Box"){
//       setMedicineDosageUnit("each");
//     }
//     else if (event == "Custom"){
//       // For custom, you might want to set a default or leave it empty
//       setMedicineDosageUnit("");
//     }
// };
  // existing
  // const handlemedicinetypechange = (event) => {
  //   setMedicineType(event);
  //   if (event == "Tablet") {
  //     setMedicineDosageUnit("mg");
  //   } else if (event == "Syrup") {
  //     setMedicineDosageUnit("ml");
  //   }
  // };

  const handleFromDateChange = (selecteddate) => {
    const formattedDate = moment(selecteddate).format("YYYY-MM-DD");
    setFromDate(formattedDate);
  };

  const handleToDateChange = (selecteddate) => {
    const formattedDate = moment(selecteddate).format("YYYY-MM-DD");
    setToDate(formattedDate);
  };

  const handleconsumptionfrequencychange = (selectedOption) => {
    // console.log('selectedOption: ', selectedOption)

    setMedicineDosageFrequency(selectedOption)
    // if (selectedOption == "1x per day") {
    //   setMedicineDosageFrequency("1");
    // } else if (selectedOption == "2x per day") {
    //   setMedicineDosageFrequency("2");
    // } else if (selectedOption == "3x per day") {
    //   setMedicineDosageFrequency("3");
    // } else if (selectedOption == "4x per day") {
    //   setMedicineDosageFrequency("4");
    // } else if (selectedOption == "0.5x per day") {
    //   setMedicineDosageFrequency("0.5")
    // }
  };

  //-------------------------------------------------
  // Delete Functionality

  const [medicationNameToDelete, setMedicationNameToDelete] = useState("");
  const [idToDelete, setidToDelete] = useState(null);
  const dynamicModal = React.useRef();

  const openDeleteModal = (id, medicationName) => {
    // console.log("Triggered");
    const immediatStateId = id;
    setidToDelete(immediatStateId);
    const immediateStateName = medicationName;
    setMedicationNameToDelete(immediateStateName);
    // console.log("Id & Name", idToDelete, medicationNameToDelete);
    if (dynamicModal.current) {
      // console.log("Opened Up the modal");
      dynamicModal.current.openModal();
    }
  };

  const deleteMedication = async () => {
    const inputForDelete = {
      input: {
        doctorid: doctorId,
        patientid: patientId,
        appointmentid: appointmentId,
        type: "medications",
        prescribedmedicineid: idToDelete,
        medicineactive: 0,
      },
    };

    try {
      showLoader();
      // console.log("input to delete", inputForDelete.input);
      const result = await updateCondition(inputForDelete.input);
      // console.log("delete result", result);
      if (result.output.result === "success") {
        showSuccessToast(`${medicationNameToDelete} has been deleted`);
        fetchPatientHealthData();
        dynamicModal.current.closeModal();
      } else {
        showErrorToast("Something went wrong!");
      }
    } catch (error) {
      console.error("Error deleting medication:", error);
      showErrorToast("An error occurred while deleting medication");
    } finally {
      dismissLoader();
    }
  };

  // --------------- Add to Orders ---------------

  const handleAddToOrders = async (medicine) => {
    // console.log('Orders medicine: ', medicine)
    const today = moment().format("YYYY-MM-DD");
    const fiveDaysFromToday = moment().add(5, "days").format("YYYY-MM-DD");
    const inputData = {
      input: {
        patientid: patientId,
        doctorid: doctorId,
        appointmentid: appointmentId,
        medicinedetail: [
          {
            id: null,
            medicinename: medicine.name,
            medicinetype: medicine.type,
            dosage: medicine.dosage,
            dosageunit: medicine.dosageunit,
            startdate: today,
            enddate: fiveDaysFromToday,
            frequency: medicine.frequency,
            frequencytime: medicine.medicineFreqUnit,
            frequencyvalue: medicine.medicineFreqValue,
            // duration: medicine.medicinge
            morning: medicine.inMorning,
            evening: medicine.inEvening,
            night: medicine.inNight,
            chemical_composition: medicine.chemicalcomposition,
            isactive: 1,
          },
        ],
      },
    };

    try {
      showLoader();
      // console.log(inputData);
      const result = await updateDoctorNotes(inputData.input);
      // console.log(result);
      if (result) {
        showSuccessToast("Medicine added to orders successfully");
        fetchPatientHealthData();
        refreshDoctorNotes();
      }
    } catch (error) {
      console.error("Error adding medicine to orders:", error);
      showErrorToast("An error occurred while adding medicine to orders");
    } finally {
      dismissLoader();
    }
  };

  // ------------------------------- Edit Functionality Start ----------------------------
    const [Composition, setComposition] = useState("");
    const [rateOfInfusionValue, setRateOfInfusionValue] = useState(null);
        const [rateOfInfusionUnit , setRateOfInfusionUnit] = useState("ml/hr")
        const [durationValue, setDurationValue] = useState(null);
        const [durationUnit, setDurationUnit] = useState(null);

        const [medicineFreqValue, setMedicineFreqValue] = useState("")
            const [medicineFreqUnit, setMedicineFreqUnit] = useState("")
                const [selectedImage, setSelectedImage] = useState(null);
              const [medicineexpirydate, setMedicineExpiryDate] = useState('');
            const [benifit, setBenifit] = useState('')
              const [sideEffects, setSideEffects] = useState('')

              const [boolValForSuggestions , setBoolValForSuggestions] = useState(true)
                const [suggestions, setSuggestions] = useState({});
                  const [showDocNamesDropdown , setShowDocNamesDropdown] = useState(true)
                  const [actionAccessPatients , setActionAccessPatients] = useState(null);
                

              // states of new inputs of medication ---
                  const [routeOfAdministration, setRouteOfAdministration] = useState(null);
                  const [timing, setTiming] = useState(null);
                  const [quantity, setQuantity] = useState(null);
                  const [areaOfApplication, setAreaOfApplication] = useState(null);
                  const [diluent, setDiluent] = useState(null);
                  const [infusionDuration, setInfusionDuration] = useState(null);
                  const [infusionFrequency, setInfusionFrequency] = useState(null);
                  const [additives, setAdditives] = useState(null);
                  const [duration, setDuration] = useState(null);

                    // const [afternoon, setAfternoon] = useState("0");
                    // const [beforefood, setBeforefood] = useState("0");
                    // const [afterfood, setAfterfood] = useState("0");
                    const [filenameArray, setFilenameArray] = useState([]);

                    const handlemedicinetimebeforeafter = (values) => {
                      if (values.includes("beforefood")) {
                        setBeforeFood(1);
                      } else {
                        setBeforeFood(0);
                      }
                    
                      if (values.includes("afterfood")) {
                        setAfterFood(1);
                      } else {
                        setAfterFood(0);
                      }
                    };
  
  const handleimageselection = async (e) => {
      e.preventDefault();
      setMedicineName("")
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
      if (!allowedTypes.includes(file.type)) {
        showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      dismissLoader();
        return false;
      }
      showLoader();
      const result = await GetMedicineName(file, file.name, file.type);
      if(result?.output?.message  == "No credits are available"){
        showErrorToast("No sufficient tokens available")
      }else{
      setMedicineName(result.medicine_name);
      setComposition(result.chemical_composition)
  
       if(result.expiry_date !== "00-0000"){
        //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
        setMedicineExpiryDate(result.expiry_date);
       }
      setBenifit(result.benefit);
      setSideEffects(result.side_effects);
    //  showmedicinename.current.openRight();
      }
      
      
    e.target.value = '';
      dismissLoader();
    };

    const makeAicall = async ()=>{
        const inputData = {
          input: {
            name: medicinename,
          },
        };
        if(medicinename){
        try {
         showLoader();
        const result = await GetAIMedicineComposition(inputData.input);
        if(result){
            // setMedicineName(result.medicine_name);
            setComposition(result.chemical_composition)
    
            if(result.expiry_date !== "00-0000"){
              //const formatteddate = moment(result.expiry_date).format("DD-MM-yyyy")
              setMedicineExpiryDate(result.expiry_date);
            }
            setBenifit(result.benefit);
            setSideEffects(result.side_effects);
            // learnMoreModal.current.openModal()
             dismissLoader();
        }
        }catch(error){
    
        }
      }
    };

    const handleRateOfInfusionUnit = (selectedOption) => {
      setRateOfInfusionUnit(selectedOption.label);
    };

    const handleMonthYearChange = (date) => {
      setMedicineExpiryDate(moment(date).format('MM-yyyy'));
    };

//     function handleFrequencyUnit(selectedOption) {
//       if(selectedOption) {

//         setMedicineFreqUnit(selectedOption)
//       }
//       setMedicineFreqUnit(selectedOption)
//   }
//   function handleFrequencyValue(selectedOption) {
                 
//     // If frequency value is selected, clear time checkboxes
//     if (selectedOption) {
//       // setTimeValues([]);
//       setMorning(0);
//       setAfternoon(0);
//       setNight(0);
//      }
//      setMedicineFreqValue(selectedOption)
//  }
  function handleDurationValue(selectedOption) {
    // console.log('selectedOption durationvalue: ', selectedOption)
      setDurationValue(selectedOption)
  }
  function handleDurationUnit(selectedOption) {
    // console.log('selectedOption durationUNIt: ', selectedOption)
    // if(selectedOption != "Until symptoms resolve"){
      setDurationUnit(selectedOption)
    // }
  }

  function handleRouteOfAdministration(selectedOption) {
    setRouteOfAdministration(selectedOption)
  }
  
  function handleTiming(e) {
    setTiming(e.target.value)
  }
  
  function handleQuantity(selectedOption) {
    setQuantity(selectedOption)
  }
  
  function handleAreaOfApplication(e) {
    setAreaOfApplication(e.target.value)
  }
  
  function handleDiluent(selectedOption) {
    setDiluent(selectedOption)
  }

  const handleSurgeonNameChange = (surgeonName) => {
    let formattedValue = surgeonName.replace(/[^0-9a-zA-Z\s.]/g, "")
    setPrescribedBy(formattedValue);

    // Filter surgeon names based on input
    if (formattedValue) {
      filterSurgeonNames(formattedValue);
    } else {
      setSuggestions([]);
    }
    setPrescribedBy(formattedValue)
  };
    const [treatmentteamdata, setTreatmentTeamData] = useState("");
  

  const listOfSurgeonNames = ( isImage) => {
 
    const allSuggestions = treatmentteamdata && treatmentteamdata
  
    setSuggestions(allSuggestions);
    // setBoolValForSuggestions(!boolValForSuggestions) 
    if(isImage){
      setShowDocNamesDropdown(!showDocNamesDropdown)
  
    }
  };

  function handleAdditives(e) {
    setAdditives(e.target.value)
  }
  const handleSelect = (suggestion) => {
    setPrescribedBy(suggestion.doctorname);
    setSuggestions([]);
  };

  const filterSurgeonNames = (surgeonName) => {
    const filtered = treatmentteamdata && treatmentteamdata.filter((surgeon) =>
      surgeon.doctorname?.toLowerCase().includes(surgeonName.toLowerCase())
    );
    setSuggestions(filtered);
  };


  // -----------------------------------------------------------

  const [morning, setMorning] = useState(0); // Default checked
const [afternoon, setAfternoon] = useState(0);
const [night, setNight] = useState(0);
  // Handle time checkbox changes
const handleTimeChange = (time) => {
  // Clear frequency inputs when checking a time
  if (time === "morning" && morning !== 1) {
    setMedicineFreqUnit("");
    setMedicineFreqValue("");
  } else if (time === "afternoon" && afternoon !== 1) {
    setMedicineFreqUnit("");
    setMedicineFreqValue("");
  } else if (time === "night" && night !== 1) {
    setMedicineFreqUnit("");
    setMedicineFreqValue("");
  }

  // Update the specific time state
  switch(time) {
    case "morning":
      setMorning(morning === 1 ? 0 : 1);
      break;
    case "afternoon":
      setAfternoon(afternoon === 1 ? 0 : 1);
      break;
    case "night":
      setNight(night === 1 ? 0 : 1);
      break;
  }
};

// Handle frequency unit change
const handleFrequencyUnit = (value) => {
  if (value) {
    // Clear time checkboxes when selecting frequency
    setMorning(0);
    setAfternoon(0);
    setNight(0);
  }
  setMedicineFreqUnit(value);
};

// Handle frequency value change
const handleFrequencyValue = (value) => {
  if (value) {
    // Clear time checkboxes when selecting value
    setMorning(0);
    setAfternoon(0);
    setNight(0);
  }
  setMedicineFreqValue(value);
};

// Handle food timing change
const handleFoodTimingChange = (value) => {
  setFoodTiming(value);
  setBeforeFood(value === "before" ? 1 : 0);
  setAfterFood(value === "after" ? 1 : 0);
};

const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};

// ----------------------- multilingual -----------------------------
// waves 
   const recorderRef = useRef(null);
     const [chunks, setChunks] = useState([]);
       const [recording, setRecording] = useState(false);
     
    const [stream, setStream] = useState(null);

    useEffect(() => {
        if (recorderRef.current) return;
    
        if (navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ audio: true })
            .then((stream) => {
              setStream(stream);
    
              recorderRef.current = new MediaRecorder(stream);
              // audioContextRef.current = new AudioContext({
              //   sampleRate: WHISPER_SAMPLING_RATE,
              // });
    
              recorderRef.current.onstart = () => {
                setRecording(true);
                setChunks([]);
              };
              recorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) {
                  setChunks((prev) => [...prev, e.data]);
                } else {
                  setTimeout(() => {
                    recorderRef.current.requestData();
                  }, 25);
                }
              };
    
              recorderRef.current.onstop = () => {
                setRecording(false);
              };
            })
            .catch((err) => console.error("The following error occurred: ", err));
        } else {
          console.error("getUserMedia not supported on your browser!");
        }
    
        return () => {
          recorderRef.current?.stop();
          recorderRef.current = null;
        };
      }, []);
    

  // ------------------------------------
  //Remove speech and keep Null to toggle between GPU and Speech
  const [SelectedLanguage, setSelectedLanguage] = useState("en-US");
  const [inpLang, setInpLang] = useState("English");
    const [instructions, setInstructions] = useState(null);
      const [editInstructions, setEditInstructions] = useState(null);

  
  function handleInstructions(value) {
    // console.log('e: ', e.target.value)
    setInstructions(value)
  }
  function handleEditInstructions(value) {
    // console.log('e: ', e.target.value)
    setEditInstructions(value)
  }
  
  const handleChangeLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; // Get the selected language
    setInpLang(selectedLanguage)
    const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found

    // Update the language in the transcriber
    setSelectedLanguage(languageCode);
    console.log("Selected Language: ", selectedLanguage);
    console.log("Language Code: ", languageCode);
  };

  const [outLang, setOutputLang] = useState("English")
  const handleChangeOutputLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; 
    // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 

    // Update the language in the transcriber
    setOutputLang(selectedLanguage);
    console.log("Selected Language OUTPUT: ", selectedLanguage);
    // console.log("Language Code OUTPUT: ", languageCode);
  };
  const language = 'hi-IN';
const { transcriber: activeTranscriber, mode } =
  useHybridTranscriber("speech", (text) => {
    // called when speech recognition finishes
    setPlaceholder(text || "");
    setTyping(false);
},
SelectedLanguage
);
// Add this state to your parent component
const [isRecording, setIsRecording] = useState(false);

// Add this function to handle recording state changes
const handleRecordingStateChange = (recording) => {
  setIsRecording(recording);
};
// ----------------------- Add/Edit REcorder------------------------------
// const activeTranscriber = useGPUTranscriber();

  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
      const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [placeholder, setPlaceholder] = useState(
    // "Click anywhere to start typing...."
    "Instructions"
  );

  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      handleInstructions(activeTranscriber.output.text);
      // setPlaceholder("Click anywhere to start typing....");
      setPlaceholder("Instructions");
      setTyping(false);
    }
  }, [activeTranscriber?.output, isAddModalOpen]);
  useEffect(() => {
    // console.log("triggered");
    if (activeTranscriber?.output?.text) {
      setValue("textField", activeTranscriber.output.text);

      handleEditInstructions(activeTranscriber.output.text);
      // setPlaceholder("Click anywhere to start typing....");
      setPlaceholder("Instructions");
      setTyping(false);
    }
  }, [activeTranscriber?.output, isEditModalOpen]);

  const { register, handleSubmit, watch, setValue } = useForm();
  const textFieldValue = watch("textField", "");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [initialText, setInitialText] = useState("");

  const onSubmit = (data) => {
      setIsButtonDisabled(true); // Disable button on submit
      // UpdateHpiTextBox(data);
      SetHPITextBox(data);
      // fetchDoctorNotesEmptyIndication();
    };
  
     // submit on tab switch and submit button is enalbed
      useEffect(()=>{
          if(!isButtonDisabled){
          handleSubmit(onSubmit)();
          }
      },[])
  
    useEffect(() => {
      if (textFieldValue !== initialText) {
        setIsButtonDisabled(false); // Enable button if text field value changes
      } else {
        setIsButtonDisabled(true); // Disable button if text field value is unchanged
      }
    }, [textFieldValue, initialText]);

const correctOrders = async (formType) => {
    // const currentText = watch("textField");
    let currentText = "";
  if (formType === "add") {
    currentText = instructions || "";
  } else if(formType === "edit") {
    currentText = editInstructions || "";
  }

  const getDoctorSpecialti = localStorage.getItem('doctorSpecialities')
  const getDoctorExp = localStorage.getItem('doctorExperience')
    
    if (!currentText) {
      showErrorToast("No text available to correct");
      return;
    }

    const inputToSave = {
      input: {
        text: currentText,
        type: `medicine_instructions#${getDoctorSpecialti}#${getDoctorExp}#ConsultationNote#${inpLang}#${outLang}`,
      },
    };

    showLoader();
    try {
      // const result = await CorrectInstructionsUsingAI(inputToSave.input);
      const result = await CorrectMedicalTermsUsingAI(inputToSave);
      if (result) {
        showSuccessToast("Updated Text");
        const updatedText = result?.text;

        if (formType === "add") {
        handleInstructions(updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      } else if (formType === "edit") {
        handleEditInstructions(updatedText);
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      }      
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error in Correct AI call:", error);
      showErrorToast("Error Happened While Correcting.");
    } finally {
      dismissLoader();
    }
};

  return (
    <Box
      display="flex"
      flexDir="column"
      alignItems="center"
      w="100%"
      bg={componentBg}
    >
      <Box display="flex" alignItems="center" w="100%">
        <Circle
          size="1rem"
          bg="white"
          border="2px solid #CDCFD4"
          borderRadius="full"
          color="black"
        />
        <Text
          fontSize="12px"
          fontWeight="500"
          textAlign="left"
          color="#384052"
          ml="0.5rem"
        >
          {formatDate(date)}
        </Text>
      </Box>
      <Box display="flex" w="100%" mt="10px">
        <Center
          w="100%"
          h="auto"
          ml="0.45rem"
          alignItems="start"
          borderLeft="2px solid #E6E7E9"
        >
          <Box w="100%">
            {medicines.map((medicine, index) => (
              <Box
                key={index}
                p="20px"
                w="100%"
                ml="10px"
                display="flex"
                flexDirection="column"
                alignItems="start"
                justifyContent="space-between"
                border="1px solid #E6E7E9"
                borderRadius="12px"
                backgroundColor={cardBg}
                mb="10px"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  w="100%"
                  justifyContent="space-between"
                  gap="10px"
                >
                  <Flex flexDir="column">
                    <Box
                      fontSize="10px"
                      fontWeight="600"
                      bg="#E6E7E966"
                      border="1px solid #E6E7E9"
                      p="5px 10px"
                      borderRadius="full"
                      w="fit-content"
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {medicine.type ? medicine.type : "-"}
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      flex="1"
                    >
                      <Text
                        title={medicine.name}
                        fontSize="16px"
                        textAlign="left"
                        fontWeight="600"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        w={{ base: "100px", md: "220px" }}
                      >
                        {medicine?.name?.length > 30
                          ? `${medicine.name.substring(0, 30)}...`
                          : medicine.name}
                      </Text>
                    </Box>
                  </Flex>
                  <Box display="flex" alignItems="center">

                                            <Box
                          as="button"
                          border="1px solid #E6E7E9"
                          borderRadius="full"
                          w="36px"
                          h="auto"
                          p="10px"
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          onClick={isChatbotAllowed() ? () => fetchAiDoctorPrompts(medicine.name) : null}
                          cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
                          opacity={isChatbotAllowed() ? 1 : 0.5}
                          bg={isChatbotAllowed() ? "transparent" : "gray.100"}
                          _hover={
                            isChatbotAllowed() 
                              ? { bg: "gray.50", borderColor: "gray.300" } 
                              : {}
                          }
                          title={
                            !isChatbotAllowed() 
                              ? "Please upgrade your subscription to use AI features" 
                              : "Get AI suggestions"
                          }
                        >
                          <Image 
                            w="26px" 
                            src="/assets/svgs/ai-star-outline.svg" 
                            opacity={isChatbotAllowed() ? 1 : 0.5}
                            filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
                          />
                        </Box>
                    {/* <Box
                      as="button"
                      // onClick={}
                      border="1px solid #E6E7E9"
                      borderRadius="full"
                      w="36px"
                      h="auto"
                      p="10px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      onClick={() => fetchAiDoctorPrompts(medicine.name)}
                    >
                      <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
                    </Box> */}
                    <Box
                      as="button"
                      border="1px solid #E6E7E9"
                      borderRadius="full"
                      w="36px"
                      h="auto"
                      p="10px"
                      ml="10px"
                      onClick={() => handleeditmedication(medicine)}
                    >
                      <Image w="13px" src="/assets/svgs/edit-gray.svg" />
                    </Box>
                    <Box
                      as="button"
                      border="1px solid #E6E7E9"
                      borderRadius="full"
                      w="36px"
                      h="auto"
                      p="10px"
                      ml="10px"
                      onClick={() =>
                        openDeleteModal(medicine.id, medicine.name)
                      }
                    >
                      <Image w="13px" src="/assets/imgs/delete.png" />
                    </Box>
                  </Box>
                </Box>
                <Divider my="10px" />
                <Box display="flex" alignItems="center" w="100%">
                  <Box display="flex" alignItems="center">
                    <Image
                      src={
                        medicine.type === "Tablet"
                          ? "/assets/svgs/pill-blue.svg"
                          : "/assets/svgs/syrup.svg"
                      }
                      w="16px"
                      mr="5px"
                    />
                    <Text
                      fontSize="14px"
                      fontWeight="500"
                      color="#384052"
                      whiteSpace="nowrap"
                    >
                      {medicine.frequency ? medicine.frequency : "-"} Qty
                    </Text>
                    {medicine.frequencytime && medicine.frequencyvalue ? (
                                      <Box display="flex" gap="5px" ml="5px">
                                      <Text
                                      fontSize="14px"
                                      fontWeight="500"
                                      color="#384052"
                                      whiteSpace="nowrap"
                                      >
                                        {medicine.frequencytime === "Hours"
                                        ? `Every ${medicine.frequencyvalue} ${medicine.frequencytime}`
                                        : `${medicine.frequencytime} ${
                                          medicine.frequencyvalue === 1
                                              ? "once"
                                              : medicine.frequencyvalue === 2
                                              ? "twice"
                                              : medicine.frequencyvalue === 3
                                              ? "thrice"
                                              : `${medicine.frequencyvalue} times`
                                          }`}
                                        </Text>
                                        </Box>
                                    ):(
                                      <>
                    <Box display="flex" gap="5px" ml="5px">
                      <Box
                        as="span"
                        bg={medicine.inMorning === 1 ? "#384052" : "#E6E7E9"}
                        borderRadius="full"
                        w="8px"
                        h="8px"
                        p="4px"
                      ></Box>
                      {/* <Box
                        as="span"
                        bg={medicine.inAfternoon === 1 ? "#384052" : "#E6E7E9"}
                        borderRadius="full"
                        w="8px"
                        h="8px"
                        p="4px"
                      ></Box> */}
                      <Box
                        as="span"
                        bg={medicine.inAfternoon === 1 ? "#384052" : "#E6E7E9"}
                        borderRadius="full"
                        w="8px"
                        h="8px"
                        p="4px"
                      ></Box>
                      <Box
                        as="span"
                        bg={medicine.inNight === 1 ? "#384052" : "#E6E7E9"}
                        borderRadius="full"
                        w="8px"
                        h="8px"
                        p="4px"
                      ></Box>
                    </Box>
                    </>
                  )}
                  </Box>
                  <Box flex="1" />
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    w="100%"
                  >
                    <Image
                      src="/assets/svgs/calendar_month.svg"
                      w="16px"
                      mr="5px"
                    />
                    <Text fontSize="14px" fontWeight="500" color="#384052">
                      {/* {medicine.duration} */}
                      {medicine.iscurrentmedicine}
                    </Text>
                  </Box>
                </Box>
                <Divider my="10px" />
                <Button
                  w="100%"
                  alignItems="center"
                  color="blue"
                  bg="#f3f3f5"
                  onClick={() => handleAddToOrders(medicine)}
                >
                  + Add to orders
                </Button>
              </Box>
            ))}
            <Box mt="4px" p="10px" w="100%">
              <Box display="flex" w="100%" flexWrap="wrap">
                {" "}
                {attachments.map((attachment, index) => (
                  <Box
                    key={index}
                    display="flex"
                    alignItems="center"
                    border="1px solid #E6E7E9"
                    borderRadius="8px"
                    p="5px 10px"
                    mr="10px"
                    mb="10px"
                    backgroundColor="white"
                  >
                    <Box bg="#f9f9f9" p="5px" borderRadius="8px">
                      <Image src={getFileIcon(attachment.name)} w="16px" />
                    </Box>
                    <Link
                      href={attachment.link}
                      isExternal
                      fontSize="14px"
                      color="#2B6CB0"
                      ml="5px"
                    >
                      {attachment.name}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Center>
      </Box>

      {/* --------------------------------------------- */}
      <ModalRight
        ref={editmedications}
        header="Update Medication"
        bodyStyle={{ p: "24px 32px" }}
        modalWidth="460px"
        body={
          <>
            <Box display="flex" flexDir="column" gap="20px">
              <Stack spacing={4}>
                <InputGroup>
                  <Input
                    pr="4.5rem" // Padding right to make room for the icon
                    type="text"
                    placeholder="Medicine name*"
                    value={medicinename}
                    sx={{
                      height: "48px",
                      borderRadius: "10px",
                      _hover: {
                        border: "2px solid",
                        borderColor: COLORS.INPUT_FOCUS_DARK,
                        outline: "none",
                        bg: "none",
                        _focus: {
                          borderRadius: "10px",
                          borderColor: COLORS.INPUT_FOCUS_DARK,
                          outline: "none",
                        },
                        _focusVisible: { borderColor: "none" },
                      },
                    }}
                    maxLength={80}
                    onChange={handlemedicinename}
                  />
                  <InputRightElement width="4.5rem">
                    <Box
                      as="button"
                      h="1.75rem"
                      bg="none"
                      pt="8px"
                      onClick={() =>
                        document.getElementById("file-upload").click()
                      }
                      sx={{ _hover: { bg: "none" } }}
                    >
                      <Image src="/assets/svgs/image-search-blue.svg" />
                    </Box>
                    <input
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }}
                      //onChange={(e) => setFile(e.target.files[0])}
                      onChange={handleimageselection}
                    />
                  </InputRightElement>
                </InputGroup>
                <InputGroup>
                <PrimaryInput
                variant="bothSide"
                  inputValue={Composition}
                  onChange={(event)=> setComposition(event.target.value)}
                  inputPlace="Chemical Composition"
                />
                  {/* <PrimaryButton
                          buttonText="Fetch"
                          verticalAlign="bottom"
                          variant="grayBtn"
                          btnStyle={{
                            w: "15%",
                            color: COLORS.PRIMARY_COLOR,
                            verticalAlign: "bottom",
                            ml: "4px",
                            mb: "0px",
                            h: "48px",
                            m: "0",
                            borderRadius: "0 10px 10px 0",
                            opacity: isChatbotAllowed() ? 1 : 0.6,
                              cursor: isChatbotAllowed() ? "pointer" : "not-allowed"
                          }}
                          onClick={() => {
                                if (isChatbotAllowed()) {
                                  fetchComposition(medicinename);
                                } else {
                                  showErrorToast("Please upgrade your subscription to use this feature");
                                }
                              }}
                              isDisabled={!isChatbotAllowed()}
                              title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                          // onClick={() =>
                          //   fetchComposition(medicinename)
                          // }
                          // isDisabled={false}
                        /> */}
                        <Box
                            as="button"
                            type="button"
                            border="1px solid #E6E7E9"
                            // borderRadius="full"
                            width={{ base: "100%", md: "10%" }}
                            // w="40px"
                            // h="40px"
                            p="8px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            // cursor={medicineTextFieldValue ? "pointer" : "not-allowed"}
                            // opacity={medicineTextFieldValue ? 1 : 0.5}
                            // pointerEvents={medicineTextFieldValue ? "auto" : "none"}
                            onClick={() => {
                            if (isChatbotAllowed()) {
                              fetchComposition(medicinename);
                            } else {
                              showErrorToast("Please upgrade your subscription to use this feature");
                            }
                          }}
                          isDisabled={!isChatbotAllowed()}
                          title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
                            bg="white"
                            // _hover={medicineTextFieldValue ? { bg: "#f0f0f0" } : {}}
                          >
                            <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                          </Box>
                </InputGroup>
                {/* {medicinename != ''  &&
                        <Box as="button" onClick={makeAicall} textAlign="right" fontSize="12px" textDecoration="underline">Learn more</Box>
                        } */}
                <RadioGroup
                mt="1rem"
                  value={medicinetype}
                onChange={handlemedicinetypechange}
                >
                   <Divider />
                  <Stack direction="row" alignItems='center' gap="20px"  wrap="wrap">
<Radio colorScheme="green" value="Tablet">Tablet</Radio>
                                      <Radio colorScheme="green" value="Capsule">Capsule</Radio>
                                      <Radio colorScheme="green" value="Syrup">Syrup</Radio>
                                      <Radio colorScheme="green" value="Drops">Drops</Radio>
                                      <Radio colorScheme="green" value="Injection">Injection</Radio>
                                      <Radio colorScheme="green" value="Nebulization">Nebulization</Radio>
                                      <Radio colorScheme="green" value="IVFluids">IV Fluids</Radio>
                                      <Radio colorScheme="green" value="Inhaler">Inhaler</Radio>
                                      <Radio colorScheme="green" value="Sachet">Sachet</Radio>
                                      <Radio colorScheme="green" value="Ointment">Ointment</Radio>
                                      <Radio colorScheme="green" value="Cream">Cream</Radio>
                                      <Radio colorScheme="green" value="Gel">Gel</Radio>
                     {/* <Radio value="Tablet">Tablet</Radio>
                    <Radio value="Capsule">Capsule</Radio>
                    <Radio value="Syrup">Syrup</Radio>
                    <Radio value="Injection">Injection</Radio>
                    <Radio value="Ointment">Ointments / Creams / Gels</Radio>
                    <Radio value="Drops">Drops</Radio>
                    <Radio value="Nebulization">Nebulization</Radio>
                    <Radio value="IVFluids">IV Fluids</Radio>
                    <Radio value="Inhaler">Inhaler</Radio> */}

                  <Text>-Or-</Text>
                  <Box mx='1rem'>
                  <DropdownInput
                                      variant="bothSide"
                                      dropDownPlace="More Medicine Types"
                                      options={additionalMedicineTypes}
                                      onClick={(value) => handleDropdownMedTypeChange(value)}
                                      value={selectedValue}
                                      defaultOption={selectedValue || "Select more types"}
                                    />

                  </Box>
                  </Stack>
                </RadioGroup>
                <Divider />
                <Box>
                  {/* <MiniDropdownInput
                    variant="bothside"
                    options={[
                      { label: "mg", value: "mg" },
                      { label: "ml", value: "ml" },
                    ]}
                    placeholderProp="Dosage"
                    defaultValue={dosage}
                    inputVal={dosage}
                    defaultOptionProp={dosageunit}
                    onSelect={handleChangeDosageUnit}
                    handleInputChange={(e) =>
                      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                    }
                    maxLength="6"
                  /> */}

{medicinetype === "Tablet" || 
 medicinetype === "Capsule" || 
 medicinetype === "Suppository" || 
 medicinetype === "Powder" ? (
  <MiniDropdownInput
    variant="bothside"
    options={[
      { label: "mg", value: "mg" },
      { label: "mcg", value: "mcg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Strength"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Inhaler" || 
    medicinetype === "Spray" || 
    medicinetype === "Aerosol" ? (
  <MiniDropdownInput
    variant="bothside"
    options={[
      { label: "puffs", value: "puffs" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Dosage"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Syrup" ||
    medicinetype === "IVFluids" ||
    medicinetype === "Nebulization" ||
    medicinetype === "Drops" ||
    medicinetype === "Injection" ||
    medicinetype === "Suspension" ||
    medicinetype === "Respules" ||
    medicinetype === "Gargle" ||
    medicinetype === "Shampoo" ||
    medicinetype === "Topical Cleanser" ? (
  <MiniDropdownInput
    variant="bothside"
    options={[
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Volume"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Ointment" ||
    medicinetype === "Cream" ||
    medicinetype === "Gel" ||
    medicinetype === "Foam" ||
    medicinetype === "Lotion" ||
    medicinetype === "Tube" ||
    medicinetype === "Soap" ? (
  <MiniDropdownInput
    variant="bothside"
    options={[
      { label: "grms", value: "grms" },
      { label: "ml", value: "ml" },
    ]}
    placeholderProp="Amount"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "EA" || 
    medicinetype === "Device" || 
    medicinetype === "Box" ? (
  <MiniDropdownInput
    variant="bothside"
    options={[
      { label: "each", value: "each" },
    ]}
    placeholderProp="Count"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : medicinetype === "Sachet" ? (
  <MiniDropdownInput
    variant="bothside"
    options={[
      { label: "mg", value: "mg" },
      { label: "g", value: "g" },
    ]}
    placeholderProp="Content"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
) : (
  <MiniDropdownInput
    variant="bothside"
    options={[
      { label: "mg", value: "mg" },
      { label: "ml", value: "ml" },
      { label: "grms", value: "grms" },
      { label: "puffs", value: "puffs" },
      { label: "each", value: "each" },
    ]}
    placeholderProp="Dosage"
    onSelect={handleChangeDosageUnit}
    handleInputChange={(e) =>
      setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
    }
    inputVal={dosage}
    defaultOptionProp={dosageunit}
    maxLength="6"
  />
)}

                  {/* latest existing */}
                  {/* {medicinetype == "Tablet" || medicinetype == "Capsule" ?
                                  (
                                      <MiniDropdownInput
                                      variant="bothside"
                                      options={ [
                                      { label: "mg", value: "mg" },
                                      { label: "mcg", value: "mcg" },
                                      { label: "g", value: "g" },
                                        ] }
                                  
                                      placeholderProp={  medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Strength"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  ): medicinetype === "Inhaler" ? (
                                    <MiniDropdownInput
                                      variant="bothside"
                                      // options={[{ label: "puffs", value: "puffs" }]}
                                      options={ [
                                        { label: "puffs", value: "puffs" },
                                        { label: "ml", value: "ml" },
                                      { label: "grms", value: "grms" },
                                        ] }
                                  
                                      placeholderProp={medicinetype == "Inhaler" ? "Volume" :  "Strength"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  ) : medicinetype === "Syrup" || medicinetype === "IVFluids" || medicinetype === "Nebulization" || medicinetype === "Drops" || medicinetype === "Injection" ? (
                                    <MiniDropdownInput
                                      variant="bothside"
                                      // options={[{ label: "puffs", value: "puffs" }]}
                                      options={ [
                                        { label: "ml", value: "ml" },
                                        ] }
                                  
                                      placeholderProp={ medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Strength"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  ) : (
                                    <MiniDropdownInput
                                      variant="bothside"
                                      options={ [
                                      { label: "mg", value: "mg" },
                                      { label: "ml", value: "ml" },
                                      { label: "grms", value: "grms" },
                                        ] }
                                  
                                      placeholderProp={  medicinetype == "Syrup" || medicinetype == "Injection" ||  medicinetype == "Nebulization" ||  medicinetype == "IVFluids" || medicinetype == "Drops"  ? "Volume" :  "Strength"}
                                      onSelect={handleChangeDosageUnit}
                                      handleInputChange={(e) =>
                                        setMedicineDosage(validationOfNumberWithOnly1Decimal(e.target.value))
                                      }
                                      inputVal={dosage}
                  
                                      defaultOptionProp={dosageunit}
                                      maxLength="6"
                                    />
                                  )} */}

                  <Box display="flex" flexDir="row">
                  {/* <PrimaryInput

                      variant="bothSide"
                      id="vitaldate"
                      inputType="date"
                      inputPlace="From"
                      inputStyleCss={{ w: "50%" }}
                      defaultValue={fromdate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                    <PrimaryInput
                      variant="bothSide"
                      id="vitaldate"
                      inputType="date"
                      inputPlace="To"
                      inputStyleCss={{ w: "50%" }}
                      defaultValue={todate}
                      onChange={(e) => setToDate(e.target.value)}
                    /> */}
                      {/* <DatePicker 
                      disableFutureDates={true}
                      defaultDate={fromdate} 
                      onDateChange={(selectedDateValue) =>
                        handleFromDateChange(selectedDateValue)
                      }
                      placeholderProp={"Start Date"} 
                      calendarStlye={{left: "-18px",  right: "unset"}}
                      maxDate={maxDateStateEdit}
                    />
                    <DatePicker 
                      defaultDate={todate} 
                      onDateChange={(selectedDateValue) =>
                        handleToDateChange(selectedDateValue)
                      }
                      placeholderProp={"End Date"} 
                      calendarStlye={{transform: "scale(0.9)", right: "-22px", top: "30px"}}
                      
                      disablePastDates={true}
                      
                      minDate={minDateStateEdit}
                      
                    /> */}


                  </Box>
                 
                 {/* New inputs in edit form Start ||----    */}
                 {medicinetype == "IVFluids" &&

<MiniDropdownInput
  variant="bothside"
  options={[
    { label: "ml/hr", value: "ml/hr" },
    { label: "ml/min", value: "ml/min" },
    // { label: "grms/hr", value: "grms/hr" },
  ]}
  handleInputChange={(e) =>
    setRateOfInfusionValue(validationOfNumberWithOnly1Decimal(e.target.value))
  }
  placeholderProp={"Rate of Infusion"}
  onSelect={handleRateOfInfusionUnit}
  maxLength="6"
  defaultOptionProp={rateOfInfusionUnit}
   defaultValue={rateOfInfusionValue}
/>

}

<Box display="flex" flexDir="row">


</Box>

{/* <Divider my="10px" /> */}
{/* <Text fontSize="0.875rem" fontWeight="500" mb="10px">{medicinetype == "Ointment" ? "Application Frequency" : "Frequency"}</Text> */}
<DropdownInput
variant="downSide"
dropDownPlace={medicinetype == "Ointment" ? "Application Frequency" : medicinetype == "Nebulization" || medicinetype == "Inhaler" || medicinetype == "IVFluids" ? "Frequency" : "Consumption Quantity"}
options={["0.5", "1", "2", "3", "4"]}
onClick={handleconsumptionfrequencychange}
// defaultOption={frequency}
value={frequency}

/>
{/* <DropdownInput
variant="bothSide"
dropDownPlace="Frequency Interval"
options={["Hours", "Days", "Weeks", "Months", "Years"]} // Interval units as options
onClick={handleFrequencyUnit}
defaultOption={medicineFreqUnit}
/> */}

<Divider my="10px" />


{(medicinetype == "Injection" || medicinetype == "Tablet" ||medicinetype == "Capsule" ) &&
<>
{/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        // defaultOption={durationUnit}
        value={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        // defaultOption={durationValue}
        value={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />
  </>
  }

{(medicinetype == "Injection") &&
<>
 

  <DropdownInput
    variant="downSide"
    dropDownPlace="Route of Administration"
    options={["Intravenous (IV)", "Intramuscular (IM)", "Subcutaneous (SC)"]}
    onClick={handleRouteOfAdministration}
    defaultOption={routeOfAdministration}
  />
  <Box>
    <PrimaryInput
      variant={"bothSide"}
      onChange={handleTiming}
      inputPlace="Timing"
      defaultValue={timing}
    />
  </Box>

</>
}

{(medicinetype == "Ointment") &&
<>

  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Application Duration</Text>
  <Box display="flex" flexDir="row">
    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Days", "Weeks", "Months", "Years"]} // Interval units as options
        onClick={handleDurationUnit}
        // defaultOption={durationUnit}
        value={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        value={durationValue}
        // defaultOption={durationValue}
      />
    </Box>

  </Box>

  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Quantity"
    options={["Pea-sized", "Thin layer", "Fingertip unit (FTU)", "Half a fingertip"]}
    onClick={handleQuantity}
    defaultOption={quantity}
  />
  <PrimaryInput
    variant={"bothSide"}
    onChange={handleAreaOfApplication}
    inputPlace="Area of Application"
    defaultValue={areaOfApplication}
  />
</>
}


{(medicinetype == "Nebulization") &&
<>

  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>

  <Box display="flex" flexDir="row">

    <Box width="50%">
      <DropdownInput
        variant="bothSide"
        dropDownPlace="Duration"
        options={["Hours", "Days", "Weeks", "Months", "Years"]}
        onClick={handleDurationUnit}
        // defaultOption={durationUnit}
        value={durationUnit}
      />
    </Box>
    <Box width="50%">
      <DropdownInput
        variant="downSide"
        dropDownPlace="Interval Value"
        options={["1", "2", "3", "4", "5", "6", "7",]}
        onClick={handleDurationValue}
        // defaultOption={durationValue}
        value={durationValue}
      />
    </Box>
  </Box>
  <Divider my="10px" />

  <DropdownInput
    variant="downSide"
    dropDownPlace="Diluent"
    options={["Normal saline", "Distilled water" , "3% saline"]}
    onClick={handleDiluent}
    defaultOption={diluent}
  />

</>
}


{(medicinetype == "IVFluids") &&
<>
  {/* <Divider my="10px" /> */}
  <Text fontSize="0.875rem" fontWeight="500" mb="10px">Infusion Duration</Text>

  <DropdownInput
    variant="downSide"
    dropDownPlace="Infusion frequency"
    options={["1", "2", "3", "4", "5", "6", "7",]}
    onClick={handleDurationValue}
    // defaultOption={durationValue}
    value={durationValue}
  />
  <DropdownInput
    variant="bothSide"
    dropDownPlace="Infusion Duration"
    options={["Hours", "Days", "Weeks", "Months", "Years"]}
    onClick={handleDurationUnit}
    // defaultOption={durationUnit}
    value={durationUnit}
  />

  <Divider my="10px" />

  <PrimaryInput
    variant={"bothSide"}
    onChange={handleAdditives}
    inputPlace="Additives"
    defaultValue={additives}
  />


</>
}

{(medicinetype == "Inhaler") &&
                                      <>
                  
                                        {/* <Divider my="10px" /> */}
                                        <Text fontSize="0.875rem" fontWeight="500" mb="10px">Duration</Text>
                  
                                        <Box display="flex" flexDir="row">
                  
                                          <Box width="50%">
                                            <DropdownInput
                                              variant="bothSide"
                                              dropDownPlace="Duration"
                                              options={["Hours", "Days", "Weeks", "Months", "Years"]}
                                              onClick={handleDurationUnit}
                                              // defaultOption={durationUnit}
                                              value={durationUnit}
                                            />
                                          </Box>
                                          <Box width="50%">
                                            <DropdownInput
                                              variant="downSide"
                                              dropDownPlace="Interval Value"
                                              options={["1", "2", "3", "4", "5", "6", "7",]}
                                              onClick={handleDurationValue}
                                              // defaultOption={durationValue}
                                              value={durationValue}
                                            />
                                          </Box>
                                        </Box>
                                        <Divider my="10px" />
                  
                                      </>
                                    }
{/* New inputs in edit form End ----|| */}

                  {/* <PrimaryInput
                    inputPlace="Medicine Expiry"
                    variant="defaultSide"
                    defaultValue={medicineexpirydate}
                    inputValue={medicineexpirydate}
                    onChange={(event) => handleExpiryDateChange(event.target.value)}
                  /> */}
                  {/* <DatePickerMonthYear */}
                  {/* <MonthYearPicker
        placeholderProp="Medicine Expiry"
        value={medicineexpirydate}
        onDateChange={handleMonthYearChange}
        datePickerInputStyle={{ borderRadius: "0!important" }}
        
        defaultDate={medicineexpirydate}
        minYear={moment().year()}
        // minDate={moment().startOf('month')}

      /> */}
                  <CheckboxGroup colorScheme="green">
  <Stack spacing={2} pt="20px" direction="row">
    <Checkbox 
      isChecked={morning === 1} 
      onChange={() => handleTimeChange("morning")}
    >
      Morning
    </Checkbox> 
    <Checkbox 
      w='33.33%' 
      ml='6px' 
      isChecked={afternoon === 1} 
      onChange={() => handleTimeChange("afternoon")}
    >
      Afternoon
    </Checkbox>
    <Checkbox 
      isChecked={night === 1} 
      onChange={() => handleTimeChange("night")}
    >
      Night
    </Checkbox>
  </Stack>
</CheckboxGroup>

<Text fontWeight='600' width="100%" display='flex' justifyContent='center' whiteSpace='nowrap'>- Or -</Text>

<Box display='flex'>
  <Box width='50%'>
    <DropdownInput
      variant="bothSide"
      dropDownPlace="Frequency"
      options={["Hours", "Daily", "Weekly"]}
      onClick={handleFrequencyUnit}   
      value={medicineFreqUnit}             
    />
  </Box>
  <Box width='50%'>
    <DropdownInputForVitals
      variant="bothSide"
      dropDownPlace="Value"
      options={["1", "2", "3", "4", "8"]}
      onClick={handleFrequencyValue} 
      readOnly=""
      // value={medicineFreqValue}   
      value={medicineFreqValue}
      inputValueProp={medicineFreqValue}
      onChange={(e) => {
        const value = e.target.value;
        if (value) {
          setMorning(0);
          setAfternoon(0);
          setNight(0);
        }
        setMedicineFreqValue(value);
      }}            
    />
  </Box>
</Box>

<RadioGroup 
  colorScheme="green" 
  onChange={handleFoodTimingChange} 
  value={foodTiming}
>
  <Stack spacing={2} pt="20px" direction="row">
    <Radio value="before">Before Food</Radio>
    <Radio value="after">After Food</Radio>
  </Stack>
</RadioGroup>
                  
                </Box>
                <Divider />
                <Box>
                  
                <Box w="100%" pos='relative' cursor="pointer">
                  <PrimaryInput
                    inputPlace="Prescribed by"
                    variant="defaultSide"
                    onChange={(e) =>
                      handleSurgeonNameChange(handleAlphaDotAndSpace(e.target.value,50))
                    }
                    onClick={() =>
                      listOfSurgeonNames(false)
                    }
                    defaultValue={prescribedby}
                    inputValue={prescribedby}

                    
                inputIdProp={"DoctorNameInEdit"}
                boolProp={boolValForSuggestions}
                  />
                    <Image top="33%" right="6.5%" w="15px" 
                          onClick={() =>
                            listOfSurgeonNames( true)
                          }
                            pos='absolute' src="/assets/imgs/double-arrow.png" />

                  {showDocNamesDropdown &&  suggestions.length > 0 && (
                <Menu isOpen={true}>
                <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
                  <Box pos="absolute" top="100%" left="0" w="100%" bg="white" borderTop="none" border="1px solid #E6E7E9" borderRadius="0 0 12px 12px" />
                </MenuButton>
                <MenuList w="100%" borderRadius="0 0 12px 12px" zIndex="999" bg="white" maxH="150px" overflow="hidden auto">
                  {suggestions.map((suggestion, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleSelect(suggestion)}
                      cursor="pointer"
                      p="1rem"
                      py="0.5rem"
                      borderBottom="1px solid #E6E7E9"
                    >
                      <Text fontSize="0.875rem" fontWeight="500">{suggestion.doctorname}</Text>
                    </MenuItem>
                  ))}
                  </MenuList>
                </Menu>
              )}
              </Box>
                  <PrimaryInput
                    inputPlace="Hospital name"
                    variant="downSide"
                    onChange={(e) => setHospitalname(handleAlphaNumericDotAndSpace(e.target.value))}
                    defaultValue={hospitalname}
                  />
                </Box>
                <Box mt="15px">
                  <Checkbox
                colorScheme="green"
                sx={{
                  ".chakra-checkbox__control": {
                    width: "20px",
                    height: "20px",
                    borderRadius: "5px",
                  },
                }}
                isChecked={isChecked == 1}
                onChange={handleIsCurrent}
              >
                  Current
              </Checkbox>
              </Box>

              <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
                                <Box
                                  as="form"
                                  width='100%'
                                  bg="white"
                                  pt={"2px"}
                                >
                                  <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                                    <Textarea
                                      borderRadius='0'
                                      // value={newMedicine.custommessage || ''}
                                      value={instructions || ''}
                                      onChange={(e) => {
                                  handleInstructions(e.target.value);
                                  setValue("textField", e.target.value); 
                                }}
                                      height="100%"
                                      padding="2"
                                      resize="none"
                                      // disabled={typing} // Disable when AI typing is true
                                      style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                                    />                      
                                    {!instructions && (
                                      <Text
                                        position="absolute"
                                        bottom="2"
                                        left="50%"
                                        transform="translateX(-50%)"
                                        fontSize="sm"
                                        color="gray.500"
                                        w={{ base: "100%", md: "unset" }}
                                        textAlign={{ base: "center", md: "unset" }}
                                      >
                                        {placeholder}
                                      </Text>
                                    )}
                                  </Box>
                                  
                                </Box>
                              </Box>

              {/* Audio & Language Controls Row - Highlighted Section */}
<Box
  bg="#f8f9fa"
  border="1px solid #e9ecef"
  borderRadius="8px"
  p="1rem"
  mt="1rem"
>
  <Flex
    alignItems="center"
    justifyContent="space-between"
    gap="0.5rem"
    flexWrap={{ base: "wrap", md: "nowrap" }}
  >
    {/* Input Language Dropdown */}
    <Box flex="1" minW="100px"> {/* Reduced min width */}
      <DropdownWithMultiLingual 
        menuList={{pos:'relative', right:'75px'}}
        placeholder="English"
        onClick={handleChangeLanguage}
        options={languageOptions.map(value => ({ value }))}
        title="Input Language"
      />
    </Box>
    
    {/* Audio Controls and Wave Display - FIXED FOR SMALL WIDTH */}
    <Box 
      flex="none" 
      display="flex" 
      alignItems="center" 
      justifyContent="center"
      gap="0.5rem" 
      minH="40px" 
      px="0.5rem" 
    >
      <GPUChatAudioManagerSpeechMode
        transcriber={activeTranscriber}
        mode={mode}
        setPlaceholder={setPlaceholder}
        setTyping={setTyping}
        onRecordingStateChange={handleRecordingStateChange} 
      />
      
      {/* Wave display with conditional rendering but maintaining space */}
      <Box 
        width={isRecording ? "150px" : "0"} 
        minW={isRecording ? "150px" : "0"}
        maxW={isRecording ? "200px" : "0"}
        height="30px"
        opacity={isRecording ? 1 : 0}
        transition="all 0.3s ease"
        overflow="hidden"
      >
        {isRecording && stream && (
          <AudioDisplayForClutter
            borderRadius="lg"
            stream={stream}
            width="100%"
            height="100%"
          />
        )}
      </Box>
    </Box>

    {/* Output Language Dropdown */}
    <Box flex="1" minW="100px"> {/* Reduced min width */}
      <DropdownWithMultiLingual 
        menuList={{pos:'relative', right:'75px'}}
        placeholder="English"
        onClick={handleChangeOutputLanguage}
        options={languageOptions.map(value => ({ value }))}
        title="Output Language"
      />
    </Box>

    {/* AI Correction Button */}
    <Box
      as="button"
      type="button"
      border="1px solid #E6E7E9"
      borderRadius="full"
      w="35px"
      h="35px"
      p="6px" 
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor={textFieldValue ? "pointer" : "not-allowed"}
      opacity={textFieldValue ? 1 : 0.5}
      pointerEvents={textFieldValue ? "auto" : "none"}
      onClick={() => textFieldValue && correctOrders("add")}
      flexShrink="0"
      bg="white"
      _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
    >
      <Image w="24px" src="/assets/svgs/ai-star-outline.svg" /> {/* Smaller icon */}
    </Box>
  </Flex>
</Box>

                {/* {filenameforUpload && filenameforUpload.map((filename, index) => ( */}
                {/* {documentURLForEdit?.map((document, index) => (
              
                  <Button
                    key={index}
                    w="100%"
                    h="48px"
                    my="15px"
                    borderRadius="10px"
                    border="1px solid #E6E7E9"
                    display="flex"
                    justifyContent="space-between"
                    bg="white"
                    color="#1C4EC5"
                    sx={{ _hover: { bg: "none" } }}
                    // onClick={()=>downloadDocument(`https://midocfileserver.blob.core.windows.net/midocdev/${filename}`)}
                    onClick={() => handleDeleteDocInEdit(index)}
                    cursor="pointer"
                  >
                    Document {index + 1}
                    <Box as="span">
                      <Image src="/assets/imgs/delete.png" />
                    </Box>
                  </Button>
                ))} */}
                {/* <Button fontSize="14px" fontWeight="500" w="100%" h="48px" borderRadius="10px" border="1px solid #E6E7E9" display="flex" justifyContent="space-between" bg="white" color="#1C4EC5" sx={{_hover: {bg:"none"}}}>
                  12/01/24_Report.pdf
                  <Box as="span">
                      <Image src="/assets/imgs/delete.png" />
                  </Box>
                </Button>*/}
                {/* <Box onClick={updateMedicationDocuments} as="button" display="flex" alignItems="center" gap="10px" fontSize="14px" fontWeight="600" color="#1C4EC5" textAlign="left">
                  <Image w="11px" src="/assets/imgs/add-blue.png" />
                  Add Document
                </Box> */}
                {/* <input
                  type='file'
                  id='file-upload'
                  onChange={(e) => handleMedicationUploadUpdate(e)}
                  ref={fileInputRefUpdate} // Set the ref for the file input
                  style={{ display: 'none' }} // Hide the file input
                /> */}
              </Stack>
            </Box>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" flexDirection="row" gap="15px">
              <PrimaryButton
                buttonText="Update Medication"
                onClick={editmedicine}
                btnStyle={{my: "0"}}
                
              // isDisabled={actionAccessPatients?.update ? false : true}
              />
            </Box>
          </>
        }
      />
      <DynamicModal
        ref={dynamicModal}
        modalHeader="Delete Medicine?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete. <br />
              {medicationNameToDelete ? medicationNameToDelete : "-"}
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deleteMedication}
            />
          </>
        }
      />

      <AiModal
        ref={AIChatModel}
        modalSize="540px"
        //icon="/assets/imgs/ai-doctor.png"
        header={
          <>
            <Box display="flex" flexDir="column">
              <Text
                fontSize="1rem"
                fontWeight="700"
                backgroundImage="linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)"
                color="transparent"
                backgroundClip="text"
              >
                Aira - AI
              </Text>
              <Text fontSize="0.75rem" fontWeight="400">
                Chat with your AI health guide
              </Text>
            </Box>
          </>
        }
        headerStyle={{ p: "24px 32px", lineHeight: "normal" }}
        closeBtnStyle={{ top: "18px" }}
        footerStyle={{
          maxH: "35%",
          overflow: "hidden auto",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        }}
        withoutBg={true}
        backDropBlur="10px"
        body={
          <>
            <Flex flexDirection="column" height="100%">
              <Box
                p="24px 32px"
                ref={chatContainerRef}
                className="chat-container"
                style={{ overflowY: "auto", maxHeight: "calc(100vh - 160px)" }}
              >
                {initialRender && remainingquestions.length > 0 && (
                  <Box>

                    {remainingquestions.map((step, index) => (
  <Box
    key={index}
    as="button"
    w="100%"
    p="16px"
    mb="16px"
    fontSize="14px"
    fontWeight="600"
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent="space-between"
    borderRadius="10px"
    border={isChatbotAllowed() ? "1px solid #7795DC" : "1px solid #CCCCCC"}
    bg={isChatbotAllowed() ? "#EAEDF5" : "#F5F5F5"}
    color={isChatbotAllowed() ? "#163E9E" : "#888888"}
    onClick={() => {
      if (isChatbotAllowed()) {
        GetAIAnswer(step.value);
      } else {
        showErrorToast("Please upgrade your subscription to use AI features");
      }
    }}
    className={`question-box ${animate ? "slide-in" : ""}`}
    cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
    opacity={isChatbotAllowed() ? 1 : 0.7}
    title={!isChatbotAllowed() ? "Please upgrade your subscription to use AI features" : ""}
  >
    {step.value ? step.value : "-"}
    <Image 
      src="/assets/imgs/right-icon.png" 
      opacity={isChatbotAllowed() ? 1 : 0.5}
      filter={!isChatbotAllowed() ? "grayscale(100%)" : "none"}
    />
  </Box>
))}
                    {/* {remainingquestions.map((step, index) => (
                      <Box
                        key={index}
                        as="button"
                        w="100%"
                        p="16px"
                        mb="16px"
                        fontSize="14px"
                        fontWeight="600"
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="space-between"
                        borderRadius="10px"
                        border="1px solid #7795DC"
                        bg="#EAEDF5"
                        color="#163E9E"
                        onClick={() => GetAIAnswer(step.value)}
                        className={`question-box ${animate ? "slide-in" : ""}`}
                      >
                        {step.value ? step.value : "-"}
                        <Image src="/assets/imgs/right-icon.png" ml={"10px"} />
                      </Box>
                    ))} */}
                  </Box>
                )}
                {aianswers.map((step, index) => (
                  <React.Fragment key={index}>
                    <Box
                      as="div"
                      bg="#061027"
                      p="12px 16px"
                      w="fit-content"
                      float="right"
                      borderRadius="10px 10px 1px 10px"
                      className={`answer-box ${animate ? "slide-in" : ""}`}
                    >
                      <Text fontSize="14px" fontWeight="500" color="white">
                        {step.question ? step.question : "-"}
                      </Text>
                    </Box>

                    <Box
                      as="div"
                      my="20px"
                      w="fit-content"
                      display="flex"
                      alignItems="end"
                      float="left"
                      className={`answer-box ${animate ? "slide-in" : ""}`}
                    >
                      <Image
                        bg="#061027"
                        p="4px"
                        mr="8px"
                        borderRadius="6px"
                        src="/assets/imgs/ai-chat-logo.png"
                      />
                      <Text
                        bg="#E6E7E980"
                        p="12px 16px"
                        fontSize="14px"
                        fontWeight="500"
                        color="#061027"
                        borderRadius="10px 10px 10px 1px"
                      >
                        {/* {step.answer ? step.answer : <TypingLoader />} */}
                        {step.answer ? (
                          <ReactMarkdown>{step.answer}</ReactMarkdown>
                        ) : (
                          <TypingLoader />
                        )}
                      </Text>
                    </Box>
                  </React.Fragment>
                ))}
              </Box>
            </Flex>
          </>
        }
        footerActions={
          !initialRender && (
            <Box
              p="24px 32px"
              display="flex"
              w="100%"
              h="100%"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Box w="100%">
                {remainingquestions.map((step, index) => (
                  <Box
                    key={index}
                    as="button"
                    w="100%"
                    p="16px"
                    mb="16px"
                    fontSize="14px"
                    fontWeight="600"
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    borderRadius="10px"
                    border="1px solid #7795DC"
                    bg="#EAEDF5"
                    color="#163E9E"
                    onClick={() => GetAIAnswer(step.value)}
                    className={`question-box ${animate ? "slide-in" : ""}`}
                  >
                    {step.value ? step.value : "-"}
                    <Image src="/assets/imgs/right-icon.png" ml={"10px"} />
                  </Box>
                ))}
              </Box>
            </Box>
          )
        }
      />
    </Box>
  );
};

export default Medications;
